import * as React from 'react';

export const LoginInProgress: React.StatelessComponent<{}> = props => <div>Initializing...</div>;